export default __webpack_public_path__ + "static/O0301-bfe977fa760bee88c50befb49db9d2e6.png";